import styled from 'styled-components';

export const ContainerOuter = styled.div`
    min-height: 100vh;
    background-size: 100%;
    background-position: center;
    background-image: url('/Assets/background_2.jpg');
    @media (min-width: 1000px) {
        background-size: contain;
    }
`;

export const SelectContainer = styled.div`
    height: 80vh;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @media (max-width: 1200px){
        width: 80%;
    }
`;

export const SelectContainer2 = styled.div`
    margin-bottom: 15px;
    width: 40%;
    @media (max-width: 1200px){
        width: 100%;
    }
`;

export const OptionsContainer = styled.div`
    display: flex;
    justify-content: center;
    @media (max-width: 1200px){
        flex-wrap: wrap;
    }
`;